module.exports = __webpack_public_path__ + "img/one.8a07a948.png";